<template>
  <div class="faculty-card" @click="$emit('select', faculty)">
    <lp-avatar class="faculty-avatar" :name="faculty.name" :photo="faculty.photo" />
    <div class="faculty-info">
      <div class="faculty-name">{{ faculty.name }}</div>
      <div v-if="faculty.role" class="faculty-role">{{ faculty.role }}</div>
    </div>
  </div>
</template>

<script>
import LpAvatar from './lp-avatar'

/**
 * One presenter tile in the faculty modal grid — avatar, name, role. Used for
 * both roster groups (featured speakers / speakers) in
 * components/modals.blade.php, so the two grids cannot drift apart.
 *
 * Styling stays in the global sheet (_faculty.scss / _detail-drawer.scss) with
 * the .faculty-card classes, which per-theme overrides already target.
 * Selecting a card emits `select` with the faculty record; the host opens
 * <lp-faculty-detail> with it.
 */
export default {
  name: 'lp-faculty-card',

  components: { LpAvatar },

  props: {
    faculty: { type: Object, required: true },
  },
}
</script>
